import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../../components/Table";
import TableSkeleton from "../../../components/Table/components/TableSkeleton";
import Filters from "../../../components/Filters";

import { useEffect, useState } from "react";
import { useCourses } from "./hooks/useCourses";
import GET_COURSES_LISTING from "../../../graphql/queries/courses-evaluations/getCoursesListing";
import useUser from "../../../hooks/useUser";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/CustomButton";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import GET_OPT_IN from "../../../graphql/queries/courses-evaluations/getOptIn";
import UPDATE_OPT_IN from "../../../graphql/mutations/courses-evaluations/updateOptIn";
import { toast, ToastContainer } from "react-toastify";
import toastConfiguration from "../../../data/toastConfiguration";


const CoursesEvaluationsList = () => {
  const initialState = {
    courseCode: "",
    courseTitle: "",
    selectedFiltersList: {
        courseCode: "",
        courseTitle: "",
    },
  };
  const filters = useCourses(initialState);
  const {
    state,
    setExpandFilters,
    setSelectedFiltersList,
    updateMultipleValues
  } = filters;
  const {
    courseTitle,
    courseCode,
    selectedFiltersList,
    expandFilters,
  } = state;
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const { user } = useUser();
  const { t } = useTranslation();
  const [optIn, setOptIn] = useState(false);

  const {
    loading: coursesListingLoading,
    error: coursesListingError,
    data: coursesListingData,
    refetch: coursesListingRefetch
  } = useQuery(GET_COURSES_LISTING, {
    variables: {
      page: page,
      course_title: courseTitle || "",
      course_code: courseCode || "",
      limit: 30
    }, fetchPolicy: "cache-and-network",
  });

   const { loading, error, data, refetch: refetchQuery } = useQuery(
      GET_OPT_IN);


      const [updateOptIn] =
              useMutation(UPDATE_OPT_IN);

  const handleExpand = (value) => {
    setExpandFilters(value);
  };

  useEffect(() => {
    updateMultipleValues(selectedFiltersList);
    coursesListingRefetch();
  }, [
    selectedFiltersList,
    updateMultipleValues,
    coursesListingRefetch
  ]);

  useEffect(() => {
    data && setOptIn(data?.institutionOptInStatus?.opt_in);
    //data?.institutionOptInStatus?.opt_in && coursesListingRefetch()
  }, [
    data
  ]);

  const handleRemoveFilter = (filter, value) => {
      let temp = Object.assign({}, selectedFiltersList);
      temp[filter] = "";
      setSelectedFiltersList(temp);
  };

  const userHasAccessToPermission = (permission) => {
    return user?.permissions?.find(
      (currentPermission) => currentPermission.value === permission
    );
  };

  const handleEdit = async () => {
    const toastId = toast.loading(t('updatingSettings'), toastConfiguration);

    try {
        const result = await updateOptIn({
            variables: {
                opt_in: optIn
            }
        });

        if (!result?.errors) {
            toast.update(toastId, {
                ...toastConfiguration,
                render: "Updated Succesfully",
                type: "success",
                isLoading: false,
            });
            setTimeout(() => {
                refetchQuery();
                optIn && coursesListingRefetch();
            }, "2000");

        }

    } catch (err) {
        toast.update(toastId, {
            ...toastConfiguration,
            render: t('unableToUpdate'),
            type: "error",
            isLoading: false,
        });
    }
};

  if (coursesListingLoading) {
    return (
      <TableSkeleton
        columnsPerFieldMap={{
          id_: "col-2",
          partner: "col-6",
          last_edited: "col-2",
          _: "col-2"

        }}
      />
    );
  }


  if (coursesListingError)
    return (
      <div className="text-center text-danger mx-auto">{t('errorMessage')}</div>
    );

  return (
    <main className="h-auto text-center mt-4">
      {userHasAccessToPermission("evaluationsOpt-in") && <>
        <div className='ewp-setting-type-title'>Use of Evaluations in the AsCOLA "All Evaluations" Module</div>
            <Form.Check type="checkbox" id="agree-terms" >
                <Form.Check.Input
                    type={"checkbox"}
                    className="ewp-settings-checkbox-label"
                    checked={optIn}
                    onClick={() => setOptIn(!optIn)}
                />
                <Form.Check.Label> <div className="ewp-settings-checkbox-label">
                I agree that my higher education institution’s evaluation data is visible in the “All Evaluations” module of the AsCOLA app.
                <br/>Note: If this option is unchecked, evaluation data of incoming students will only be accessible to the students who created it, via the “My Evaluations” module.
                </div>
                </Form.Check.Label>
            </Form.Check>
                    
            <Row>
              <Col style={{ marginTop: 20, marginBottom: 10, display: "flex", justifyContent: "flex-start" }}>
                  <CustomButton type="submit" buttonType={"primary"} text="Save" 
                  handleClick={handleEdit} 
                  hasIcon icon={faFloppyDisk} small />
              </Col>
            </Row>
      </>}
      <CustomTable
        page={page}
        setPage={(p) => setPage(p)}
        type={"courses-"}
        expandFilters={expandFilters}
        setExpandFilters={(e) => setExpandFilters(e)}
        filters={selectedFiltersList}
        setFilters={(filter, value) => {handleRemoveFilter(filter, value); setPage(0);}}
        columnsPerFieldMap={{
          code: "col-1",
          ects: "col-1",
          institution: "col-3",
          term: "col-3",
          title: "col-3"
        }}
        pageLimit={30}
        totalCount={coursesListingData?.courses?.pagination?.totalCount}
        hasPagination={true}
        customTitle={t('courses.totalCourses')}
        hasFilters={true}
        rowClassName="iias-listing-table-row"
        headerClassName="iias-listing-table-header"
        onClickHandlers={coursesListingData?.courses?.courses.map(({ id }) => (e) => {
          navigate("/courses/single-view/" + id);
        })}
        onMouseDownHandlers={coursesListingData?.courses?.courses.map(({ id }) => (e) => {
          e.button === 1 && window.open(window.location.origin + "/courses/single-view/" + id);
        })}
        data={coursesListingData?.courses?.courses?.map(({code, ects, institution,term,title}) => 
          ({code: code, ects: ects, institution: institution, term: term, title: title}))}
      >
      </CustomTable>
      <Filters
        expand={expandFilters}
        handleExpand={handleExpand}
        selectedFiltersList={selectedFiltersList}
        setSelectedFiltersList={(e) => {setSelectedFiltersList(e); setPage(0);}}
        countries={[]}
        type={"courses"}
      />
      <ToastContainer
                      position="bottom-left"
                      autoClose={5000}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                  />
    </main>
  );
};

export default CoursesEvaluationsList;
